import type { DeploymentEnvironment } from '@wirechunk/lib/deployment-environment.ts';

export const environment: DeploymentEnvironment =
  // The PROD check may seem redundant but it is needed so that the entire ENV object is not included in the output JS.
  !import.meta.env.PROD && import.meta.env.NODE_ENV === 'test' ? 'test' : window.wirechunk.env;
